import { render, staticRenderFns } from "./wj.vue?vue&type=template&id=1e35c03a&scoped=true"
import script from "./wj.vue?vue&type=script&lang=js"
export * from "./wj.vue?vue&type=script&lang=js"
import style0 from "./wj.vue?vue&type=style&index=0&id=1e35c03a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e35c03a",
  null
  
)

export default component.exports